import { gql } from "@apollo/client";

export const getLR = gql`
  query searchConnectionMemo($keyword: String!) {
    searchConnectionMemo(keyword: $keyword) {
      Search_Value
      _id
    }
  }
`;

export const getConnections = gql`
  query getCountOfConnectionMemoUpdate_ByConnectionMemoId($SearchId: ID!) {
    getCountOfConnectionMemoUpdate_ByConnectionMemoId(ConnectionMemoId: $SearchId) {
      _id
      Number_Of_Connections
      Search_Value
    }
  }
`;

const ConnectionMemoInputFields = [
  {
    id: Math.random() * 10,
    name: "Connection_Memo_Receive",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Received_At",
        label: "Received At",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        masterName: "Warehouse_Name",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Memo_Number",
        label: "Memo Number",
        clearField: "Branch_Code",
        type: "InputDropForQuery",
        Reference_field: ["Received_At"],
        masterName: "GetConnectionMemoUpdation",
        min: 1,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Select_Connection",
      //   Reference_field: "Memo_Number",
      //   label: "Select Connection",
      //   type: "InputDropForQuery",
      //   masterName: "getConnections",
      //   min: 1,
      //   max: Infinity,
      // },
    ],
  },
];

const formFieldupdation = [
  {
    id: Math.random() * 10,
    name: "LR Number",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "No Of Boxes",
    Input: true,
    type: "number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Short",
    Input: true,
    type: "number",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "Received",
    Input: true,
    type: "number",
    value: "",
  },
];

const formField = {
  [Math.random() * 10]: formFieldupdation,
};

export { ConnectionMemoInputFields, formField, formFieldupdation };
